import { CommonModule, NgOptimizedImage } from "@angular/common";

import { HttpClientModule } from "@angular/common/http";
import { LoaderModule } from "./loader.module";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

@NgModule({
  imports: [
    CommonModule,
    NgOptimizedImage,
    RouterModule,
  ],
  exports: [
    CommonModule,
    NgOptimizedImage,
    HttpClientModule,
    LoaderModule
  ],
})
export class SharedModule {}
